export const AUTH_PARAM_KEYS = {
  OTETSUTABI_AUTH: 'otetsutabi_auth',
  ACTION: 'action',
  BUSINESS_ID: 'businessId',
  PLAN_ID: 'planId',
};
export const OTETSUTABI_AUTH_VALUE = {
  SIGNUP: 'signup',
  SIGN_IN: 'sign_in',
};
export const ACTION_VALUE = {
  FAVORITE: 'favorite',
  FOLLOW: 'follow',
};

export type AuthParamKeys =
  typeof AUTH_PARAM_KEYS[keyof typeof AUTH_PARAM_KEYS];
export type OtetsutabiAuthValue =
  typeof OTETSUTABI_AUTH_VALUE[keyof typeof OTETSUTABI_AUTH_VALUE];
export type ActionValue = typeof ACTION_VALUE[keyof typeof ACTION_VALUE];
